import { Button } from '~/components/common/button';
import { Translate } from '~/i18n';
import { SaudiMapIcon } from '~/svgs';
import { BackArrowIcon } from '~/svgs/marketplace';

export const OnBoardPackageType = ({
   packageTypeSelection,
   resetAccountType,
}: {
   packageTypeSelection: (type: 'domestic' | 'is_umrah') => void;
   resetAccountType: () => void;
}) => {
   return (
      <div className=" py-8 px-5 h-full">
         <div className="flex flex-col w-full lg:w-[350px] gap-0.5 mb-8">
            <div
               className="flex items-center font-semibold ltr:text-right rtl:text-left text-grey-200 hover:cursor-pointer"
               onClick={() => resetAccountType()}>
               <span className="ltr:mr-3 rtl:ml-3 ">
                  <BackArrowIcon width={15} height={15} className="rtl:rotate-180" />
               </span>{' '}
               <span className="text-xs">
                  <Translate id="onboard:back to get started" />
               </span>
            </div>
            <span className="font-semibold">
               <Translate id="onboard:packages type selection title" />
            </span>
            <span className="text-xs text-grey-200">
               <Translate id="onboard:packages type selection subtitle" />
            </span>
         </div>

         <div className="flex flex-col lg:flex-row gap-10">
            <div className="rounded shadow-lg py-6 bg-white w-full lg:w-[350px]">
               {/* <div className=" mx-5 border rounded-lg">
                  <Image
                     height={200}
                     width={350}
                     src="/images/profile/umrah-type-scrn.png"
                     alt="image"
                     quality={100}
                     objectFit="cover"
                     className="rounded-default"
                  />
               </div> */}
               <div className="px-10 mt-5 mb-3 flex flex-col gap-2.5">
                  <img src="/images/dashboard/kaaba-icon.png" width={28} alt="kaaba" />
                  <span className="text-xl">
                     <Translate id="onboard:umrah only" />
                  </span>
                  <span className="text-sm text-grey-200">
                     <Translate id="onboard:umrah only description" />
                  </span>
               </div>
               <div className="px-10 pt-6 pb-2">
                  <Button
                     className="!w-full h-12 gap-3"
                     theme="outline-primary"
                     onClick={() => {
                        packageTypeSelection('is_umrah');
                     }}>
                     <>
                        <Translate id="common:select" />
                     </>
                  </Button>
               </div>
            </div>

            <div className="rounded shadow-lg py-6 bg-white w-full lg:w-[350px]">
               {/* <div className=" mx-5 border rounded-lg">
                  <Image
                     height={200}
                     width={350}
                     src="/images/profile/umrah-and-tour-type-scrn.png"
                     alt="image"
                     quality={100}
                     objectFit="cover"
                     className="rounded-default"
                  />
               </div> */}
               <div className="px-10 mt-5 mb-3 flex flex-col gap-2.5">
                  <span className="flex gap-3">
                     <SaudiMapIcon width={28} height={28} />{' '}
                     <span className="font-semibold text-lg">+</span>{' '}
                     <img src="/images/dashboard/kaaba-icon.png" width={28} alt="kaaba" />
                  </span>
                  <span className="text-xl">
                     <Translate id="onboard:tourism and umrah" />
                  </span>
                  <span className="text-sm text-grey-200">
                     <Translate id="onboard:tourism and umrah description" />
                  </span>
               </div>
               <div className="px-10 pt-6 pb-2">
                  <Button
                     className="!w-full h-12 gap-3"
                     theme="outline-primary"
                     onClick={() => {
                        packageTypeSelection('domestic');
                     }}>
                     <>
                        <Translate id="common:select" />
                     </>
                  </Button>
               </div>
            </div>
         </div>
      </div>
   );
};
